import { motion } from 'motion/react';
import type { ReactNode } from 'react';

interface Props {
  title: string;
  message: string;
  icon: ReactNode;
  iconClassName: string;
  onClose: () => void | Promise<void>;
}

export function InfoModal({
  title,
  message,
  icon,
  iconClassName,
  onClose,
}: Props) {
  return (
    <motion.div
      initial={{ scale: 0.9, y: 20 }}
      animate={{ scale: 1, y: 0 }}
      exit={{ scale: 0.9, y: 20 }}
      onClick={(e) => e.stopPropagation()}
      className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 text-center"
    >
      <div
        className={`w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center ${iconClassName}`}
      >
        {icon}
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">{title}</h2>
      <p className="text-gray-600 mb-6">{message}</p>
      <button
        onClick={onClose}
        className="w-full px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-medium hover:shadow-lg transition-all"
      >
        Понятно
      </button>
    </motion.div>
  );
}
